import { render, staticRenderFns } from "./appPaymentRecords.vue?vue&type=template&id=2ddf4f51&scoped=true"
import script from "./appPaymentRecords.vue?vue&type=script&lang=js"
export * from "./appPaymentRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf4f51",
  null
  
)

export default component.exports